const BroadcastColorSCP = [
    { text: "R", style: { borderColor: "red", color: "red" } }, 
    { text: "G", style: { borderColor: "green", color: "green"} }, 
    { text: "B", style: { borderColor: "blue", color: "blue"} }, 
    { text: "W", style: { borderColor: "white", color: "white"} }, 
    { text: "C", style: { borderColor: "cyan", color: "cyan"} }, 
    { text: "M", style: { borderColor: "magenta", color: "magenta"} }, 
    { text: "Y", style: { borderColor: "yellow", color: "yellow"} }, 
    { text: "O", style: { borderColor: "orange", color: "orange"} }, 
];

export default BroadcastColorSCP;